import {
  fadeIn,
  fadeInUp,
  fadeInLeft,
  fadeInRight,
  fadeInDown,
  fadeOut,
  fadeOutUp,
  fadeOutLeft,
  fadeOutRight,
} from 'ng-animate';

import {
  trigger,
  transition,
  useAnimation,
  AnimationTriggerMetadata,
  state,
  style,
  animate,
} from '@angular/animations';

// ENTER

export const snFadeIn: AnimationTriggerMetadata = trigger('snFadeIn', [
  transition(':enter', useAnimation(fadeIn), {
    params: { timing: 0.3 },
  }),
]);

export const snFadeInUp: AnimationTriggerMetadata = trigger('snFadeInUp', [
  transition(':enter', useAnimation(fadeInUp), {
    params: { timing: 0.3 },
  }),
]);

export const snFadeInDown: AnimationTriggerMetadata = trigger('snFadeInDown', [
  transition(':enter', useAnimation(fadeInDown), {
    params: { timing: 0.3 },
  }),
]);

export const snFadeInLeft: AnimationTriggerMetadata = trigger('snFadeInLeft', [
  transition(':enter', useAnimation(fadeInLeft), {
    params: { timing: 0.3 },
  }),
]);

export const snFadeInRight: AnimationTriggerMetadata = trigger('snFadeInRight', [
  transition(':enter', useAnimation(fadeInRight), {
    params: { timing: 0.3 },
  }),
]);

// LEAVE

export const snFadeOut: AnimationTriggerMetadata = trigger('snFadeOut', [
  transition(':leave', useAnimation(fadeOut), {
    params: { timing: 0.3 },
  }),
]);

export const snFadeOutUp: AnimationTriggerMetadata = trigger('snFadeOutUp', [
  transition(':leave', useAnimation(fadeOutUp), {
    params: { timing: 0.3, a: '0', b: '100%' },
  }),
]);

export const snFadeOutDown: AnimationTriggerMetadata = trigger('snFadeOutDown', [
  transition(':leave', useAnimation(fadeOutUp), {
    params: { timing: 0.3, a: '0', b: '-100%' },
  }),
]);

export const snFadeOutLeft: AnimationTriggerMetadata = trigger('snFadeOutLeft', [
  transition(':leave', useAnimation(fadeOutLeft), {
    params: { timing: 0.3, a: '0', b: '-100%' },
  }),
]);

export const snFadeOutRight: AnimationTriggerMetadata = trigger('snFadeOutRight', [
  transition(':leave', useAnimation(fadeOutRight), {
    params: { timing: 0.3, a: '0', b: '100%' },
  }),
]);

export const snDetailExpand: AnimationTriggerMetadata = trigger('snDetailExpand', [
  state('collapsed', style({ height: '0px', minHeight: '0' })),
  state('expanded', style({ height: '*' })),
  transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
]);
